import React, { useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Plugins } from '@capacitor/core'

import {
  IonApp,
  IonRouterOutlet,
  IonSplitPane
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

import Login from './pages/Login';
import Menu from './components/Menu';
import Home from './pages/Home';
import Messenger from './pages/Admin/Messenger/Messenger';
import Profile from './pages/Admin/Profile/Profile';
import Progress from './pages/Admin/Progress/Progress';
import UserProgress from './pages/Admin/Progress/UserProgress';
import Tasks from './pages/Admin/Progress/Tasks/Tasks';
import NoPage from './pages/NoPage';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

import {getDataJWT} from './utils/functions';

const { StatusBar } = Plugins
const App: React.FC = () => {

  useEffect(() => {
    StatusBar.setBackgroundColor({
      color: "#00a040"
    });
  });

  return (
    <IonApp>
      <IonReactRouter>
        <IonSplitPane contentId="main">
          <Menu />
          <IonRouterOutlet id="main">
            <Route path="/login" render={({ location }) =>
                !getDataJWT().claims ? (
                  <Login/>
                ) : (
                  <Redirect to="/home" />
                )
              } exact={true} />

            <Route path="/home" render={({ location }) =>
                getDataJWT().claims ? (
                  <Home/>
                ) : (
                  <Redirect to="/login" />
                )
              } exact={true} />
            <Route path="/messenger" render={( props: any ) =>
                getDataJWT().claims ? (
                  <Messenger {...props}/>
                ) : (
                  <Redirect to="/login" />
                )
              } />
            <Route path="/profile" render={( props: any ) =>
                getDataJWT().claims ? (
                  <Profile {...props}/>
                ) : (
                  <Redirect to="/login" />
                )
              } />
            <Route path="/progress" render={( props: any ) =>
                getDataJWT().claims ? (
                  <Progress {...props}/>
                ) : (
                  <Redirect to="/login" />
                )
              }/>
            <Route path="/progress/:child" render={( props: any ) =>
                getDataJWT().claims ? (
                  <UserProgress {...props}/>
                ) : (
                  <Redirect to="/login" />
                )
              } />
            <Route path="/progress/:child/pro/:evi" render={( props: any ) =>
                getDataJWT().claims ? (
                  <Tasks {...props}/>
                ) : (
                  <Redirect to="/login" />
                )
              } />
            <Route path="/nopage" component={NoPage} />
            <Route path="/" render={() => <Redirect to="/login" />} exact={true} />
          </IonRouterOutlet>
        </IonSplitPane>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
